module.exports = __webpack_public_path__ + "static/media/app-logo.418e2a90.png";